import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Ignore DOM manipulation errors from browser extensions
    if (error?.message?.includes('removeChild') || 
        error?.message?.includes('insertBefore') ||
        error?.message?.includes('not a child')) {
      console.warn('DOM error from external script, recovering...');
      this.setState({ hasError: false });
      return;
    }
    console.error('App error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '40px', textAlign: 'center', fontFamily: 'sans-serif' }}>
          <h2 style={{ marginBottom: '16px' }}>Bir hata olustu</h2>
          <p style={{ color: '#666', marginBottom: '20px' }}>Sayfa yeniden yuklenecek...</p>
          <button
            onClick={() => { this.setState({ hasError: false }); window.location.reload(); }}
            style={{ padding: '10px 24px', background: '#dc2626', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' }}
          >
            Sayfayi Yenile
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
